import React from "react";

// Lightweight SVG progress ring (Flowbite-style pattern)
export const ProgressRing = ({ value = 0, size = 44, stroke = 4, className = "", showLabel = true }) => {
    const radius = (size - stroke) / 2;
    const circ = 2 * Math.PI * radius;
    const pct = Math.max(0, Math.min(100, value));
    const offset = circ - (pct / 100) * circ;
    return (
        <div className={`relative inline-flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
            <svg width={size} height={size} className="-rotate-90">
                <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="hsl(var(--surface-3))" strokeWidth={stroke} />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke="hsl(var(--primary))"
                    strokeWidth={stroke}
                    strokeDasharray={circ}
                    strokeDashoffset={offset}
                    strokeLinecap="round"
                    style={{ transition: "stroke-dashoffset 0.5s cubic-bezier(0.22,1,0.36,1)" }}
                />
            </svg>
            {showLabel && (
                <span className="absolute font-mono-ui text-[10px] text-t2">{Math.round(pct)}</span>
            )}
        </div>
    );
};
